module.exports = __webpack_public_path__ + "img/shouxinedu.aba369fb.png";